import React from 'react';
import { motion } from 'framer-motion';
import { Users, Clock, Award, Shield } from 'lucide-react';
import useSimpleCounter from '../../hooks/useSimpleCounter';
import CustomerLogos from '../CustomerLogos/CustomerLogos';
import './StatsSection.css';

// Animated Stat Item Component
const AnimatedStatItem = ({ stat, index }) => {
  const [animatedValue, elementRef] = useSimpleCounter(
    stat.number, 
    2500, 
    index * 200 // Staggered delay: 0ms, 200ms, 400ms, 600ms
  );

  return (
    <motion.div
      ref={elementRef}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="stats-item"
    >
      <div className="stats-icon">
        <div className="stats-icon-wrapper">
          {stat.icon}
        </div>
      </div>
      <div className="stats-number">
        {animatedValue}
      </div>
      <div className="stats-label">
        {stat.label}
      </div>
      <div className="stats-description-text">
        {stat.description}
      </div>
    </motion.div>
  );
};

const StatsSection = () => {
  const stats = [
    {
      icon: <Users className="w-8 h-8" />,
      number: "500+",
      label: "Happy Clients",
      description: "Satisfied customers across India"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      number: "24/7",
      label: "Support Available",
      description: "Round-the-clock technical assistance"
    },
    {
      icon: <Award className="w-8 h-8" />,
      number: "25+",
      label: "Years Experience",
      description: "Industry expertise and reliability"
    },
    {
      icon: <Shield className="w-8 h-8" />,
      number: "1000+",
      label: "Projects Completed",
      description: "Successful installations and repairs"
    }
  ];

  return (
    <section className="stats-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="stats-header"
        >
          <h2 className="stats-title">
            Trusted by Industry Leaders
          </h2>
          <p className="stats-description">
            Trusted since 2005 — over 25 years of experience in industrial flow control. Our commitment to excellence has made us the preferred choice across India.
          </p>
        </motion.div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <AnimatedStatItem key={index} stat={stat} index={index} />
          ))}
        </div>

        {/* Customer Logos */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="stats-customer-logos"
        >
          {/* <h3 className="stats-customer-logos-title">
            Trusted by Leading Companies
          </h3> */}
          <div className="stats-customer-logos-container">
            <CustomerLogos />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;
